import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice";

export default function BoltForYou({ data }) {
  const dispatch = useDispatch();
  return (
    <>
      <section className="bolt-for-you-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="bolt-for-you-head">
                <div className="row">
                  <div className="col-lg-7 col-xl-5">
                    <span>{data && data.text} <br />{data && data.text2}</span>
                    <h3 className="heading">{data && data.title}</h3>
                    <button onClick={() => dispatch(openPopup())} className="default-white">{data && data.btn}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
